import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { ReglesGestionState, state } from './state';
import { mutations } from './mutations';
import { getters } from './getters';

const module: Module<ReglesGestionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    getters,
};

export default module;
export type { ReglesGestionState };
